import { useState, useEffect, useCallback } from 'react'
import { getDeviceFingerprint } from '@/lib/fingerprint'
import { storage } from '@/store/storage'
import { authApi, usersApi, type UserProfile } from '@/lib/api'

export function useAuth() {
  const [user, setUser] = useState<UserProfile | null>(null)
  const [loading, setLoading] = useState(true)
  const [ready, setReady] = useState(false)

  const register = useCallback(async () => {
    let deviceId = storage.getDeviceId()
    if (!deviceId) {
      deviceId = await getDeviceFingerprint()
      storage.setDeviceId(deviceId)
    }

    try {
      const res = await authApi.register(deviceId)
      const data = res.data as unknown as { token: string; user: UserProfile }
      if (data.token) {
        storage.setAuthToken(data.token)
      }
      if (data.user) {
        setUser(data.user)
      }
    } catch (e) {
      console.error('Registration failed:', e)
    } finally {
      setLoading(false)
      setReady(true)
    }
  }, [])

  useEffect(() => {
    const token = storage.getAuthToken()
    if (token) {
      usersApi.getProfile().then((res: unknown) => {
        const data = (res as { data: UserProfile }).data
        setUser(data)
        setLoading(false)
        setReady(true)
      }).catch(() => {
        register()
      })
    } else {
      register()
    }
  }, [register])

  return { user, setUser, loading, ready }
}
